@switch (columnName) {
  @case ('plannedStart') {
    {{ element.from | date: dateTimeFormat }}
  }
  @case ('plannedEnd') {
    <div class="text-icon-container">
      {{ element.to | date: dateTimeFormat }}
      @if (element.signOffOverdue) {
        <mat-icon class="warn" [matTooltip]="'signOffOverdueText' | translate">warning</mat-icon>
      }
    </div>
  }
  @case ('shift') {
    {{ element.shift ?? 'all' | translate }}
  }
  @case ('from') {
    @if (element.from) {
      {{ element.from | date: dateTimeFormat }}
    }
  }
  @case ('to') {
    @if (element.to) {
      {{ element.to | date: dateTimeFormat }}
    }
  }
  @case ('position') {
    {{ element.position?.name }}
  }
  @case ('period') {
    {{ element | dateDiff }} {{ 'days' | translate }}
  }
  @case ('userStatus') {
    {{ element.status | tripUserStatus | translate }}
  }
  @case ('status') {
    <app-ui-pill [name]="tripStatus" [customLabel]="true">
      {{ tripStatus | translate }}
    </app-ui-pill>
  }
  @case ('crew') {
    @if (element.crewMembersCount) {
      {{ element.crewMembersCount }} {{ 'members' | translate }}
    }
  }
  @case ('department') {
    {{ element.department?.name }}
  }
  @case ('description') {
    <app-text-overflow-label [text]="element.description"></app-text-overflow-label>
  }
  @case ('roles') {
    @for (role of element.roles; track role) {
      <div>
        {{ role.name }}
      </div>
    }
  }
  @case ('name') {
    @if (element.crewMembersCount === undefined) {
      <div class="display-flex align-items-center">
        <app-ui-navigate-to-person [id]="element.userId" type="user"></app-ui-navigate-to-person>
        {{ element.name }}
      </div>
    } @else {
      {{ element.name }}
    }
  }
  @default {
    {{ element[columnName] }}
  }
}
